import React, { useState } from "react";
import { useGetRatingSpreadsQuery } from "../../../redux/service/modules/admin";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import RatingSpreadDialog from "./RatingSpreadDialog";

const RatingSpreadDetails = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);
    return (
        <Layout>
            <CustomAdminLayout
                title={"Rating Spread Details"}
                createButtonText={"Add New Rating Spread"}
                createOnClick={() => {
                    setOpen(true);
                }}
                showSearchInput
                showCreateButton={true}
                onSearch={handleSearch}
                searchPlaceholder={"Search Rating Spreads"}
            >
                <PaginatedDataTable
                    queryHook={useGetRatingSpreadsQuery}
                    title="Rating Spread Management"
                    paginationEnabled={true}
                    showEditColumn={false}
                    showCheckboxColumn={false}
                    appliedFilters={{ search: searchText }}
                    dialogType={"ratingspread"}
                />
                <RatingSpreadDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isEdit={false}
                    title={"Add New Rating Spread"}
                    ctaText={"ADD RATING SPREAD"}
                />
            </CustomAdminLayout>
        </Layout>
    );
};

export default RatingSpreadDetails;
